import './home.scss';
import { data } from '../../data-en';
import { Link } from 'react-router-dom';
import Hero from '../../components/hero/hero-en';
import { BsArrowRight } from 'react-icons/bs'
import imgPlaceholder from '../../assets/images/placeholder.jpg';
import imgWholesale from '../../assets/images/wholesale.png';
import imgFlorinLogo from '../../assets/images/brands/florin.png';
import imgMaestroLogo from '../../assets/images/brands/maestro.png';
import imgPureLandLogo from '../../assets/images/brands/pure-land.png';
import imgSoulLogo from '../../assets/images/brands/soul.png';
import imgMainCsom from '../../assets/images/maincsom.png'
import useGaTracker from '../../hooks/useGaTracker';
import usePageTitle from '../../hooks/usePageTitle';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Home() {
    useGaTracker();
    usePageTitle('Szildán - Affordable quality', true);

    return (
        <div className='home'>
            <Hero />
            <div className="wrapper-container">
                <div className="row mb-90">
                    <div className="col-50">
                        <div className='highlighted'>
                            <div className="content">
                                <div>
                                    <h1 className="title">Wholesale trade</h1>
                                    <p className='above__button'>
                                        In our wholesale warehouse since 2009 we have been striving to continuously expand our range of products in addition to our permanent products.
                                    </p>
                                    <Link to="/wholesale" className="button">Next<BsArrowRight /></Link>
                                </div>
                            </div>
                            <div className="thumbnail">
                                <img src={imgWholesale} alt="Wholesale" />
                            </div>
                        </div>
                    </div>
                    <div className="col-50">
                        <div className='highlighted'>
                            <div className="content">
                                <div>
                                    <h1 className="title">Packaging factory</h1>
                                    <p className='above__button'>
                                        In the packaging plant dry goods are packed by experts so that we can provide our customers with quality products.
                                    </p>
                                    <Link to="/packaging" className="button">Next<BsArrowRight /></Link>
                                </div>
                            </div>
                            <div className="thumbnail">
                                <img src={imgMainCsom} alt="Packaging factory" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="home__title">
                    <h1>Products</h1>
                    <div className="divider"></div>
                </div>
                <div className="card">
                    {data.categories.map((category) => (
                        <Link to={`/products/${category.id}`} key={category.id} className="category-card-link">
                            <div className="card-box">
                                <div className="card-info">
                                    <div className="image-box">
                                        <LazyLoadImage alt={category.title} src={category.image ? category.image : imgPlaceholder} />
                                    </div>
                                    <div className='card__height'>
                                        <h1 className="product__title">{category.title}</h1>
                                        <p>{category.description}</p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <div className="section-title">
                <h1>Featured brands</h1>
            </div>
            <div className="wrapper-container">
                <div className="highlighted-brands">
                    <div className='pure-land'>
                        <img src={imgPureLandLogo} alt="Pure Land" />
                    </div>
                    <div className='maestro'>
                        <img src={imgMaestroLogo} alt="Maestro" />
                    </div>
                    <div className='florin'>
                        <img src={imgFlorinLogo} alt="Florin" />
                    </div>
                    <div className='soul'>
                        <img src={imgSoulLogo} alt="Soul" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
